import filterWhite from "../../assets/images/filterWhite.png";
import filterDark from "../../assets/images/filterDark.png";
import { IsDarkModeProp } from "../../Components/common/types";
import { styled } from "styled-components";
import { useCallback, useState } from "react";
import CustomCheckBox from "./customCheckBox";
import { Squarebtn } from "../../Components/common/squareBtnProps";
import { useTheme as styledTheme } from "styled-components";
// import { inputContainerStyle } from "../../Components/ui/Forms/contactForm";
import { filterOptions, getCustomStylesMultiSelect } from "./CustomSelectInput";
import Select from "react-select";//{ MultiValue } might be needed later
import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import useDatePickerSlotProps from "./datePickerSlotsProps";
import Box from "@mui/material/Box";
import useMediaQuery from "../../hooks/useMediaQuerryHook";

const FilterWrapper = styled.div`
  // border: 1px solid red;
  padding: 0 10px;

  @media (max-width: 992px) {
    width: 70%;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
  width: 45%;

  display: flex;
  justify-content: start;
  font-size: 14px;
  font-weight: 300;
  span {
    cursor: pointer;
  }

   .filterOpenerBtn {
      background:  ${({ theme }) => theme.text};
      color: ${({ theme }) => theme.circularIconTextBg};
      border: 1px solid ${({ theme }) => theme.text};
      border-radius: 50%;
      width: 26px;
      height: 26px;
      display: inline-block;
      cursor: pointer;
      font-size: 14px;


      &:hover, &:focus {
        background: ${({ theme }) => theme.circularIconTextBg};
         color: ${({ theme }) => theme.text};
               border: 1px solid ${({ theme }) => theme.text};
      }
    }
`;

const SearchIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 7px;
`;

const FilterContainer = styled.div`
  // border: 1px solid red;
  @media (max-width: 992px) {
    width: 80%;
  }
  @media (max-width: 768px) {
    width: 90%;
  }
  width: 70%;

  height: auto;
    @media (max-width: 576px) {
    height: 50vh;
    overflow-y: auto;
  }
  padding: 30px;

  box-shadow: ${({ theme }) => theme.shadowBox};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.body};

  .filterHeader {
    font-weight: bold;
    font-size: 20px;
  }

  .filterHeaderAndCloseBtn {
    margin-bottom: 3rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .closeBtn {
      background: rgba(255, 0, 0, 0.1);
      color: white;
      border: none;
      border-radius: 50%;
      width: 48px;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      font-size: 20px;

      &:hover {
        background: rgba(255, 0, 0, 1);
      }
      &:focus {
        background: darkred;
      }
    }
  }

  .buttonAlignment {
    margin-top: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .marginTopBottom {
    margin: 40px 0;
  }
`;

const ModalBackground = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

   z-index: 999;
  background: rgba(0, 0, 0, 0.5);
`;

const FilterComponent = () => {
  const sharedSlotsProps = useDatePickerSlotProps();
  const isMobile = useMediaQuery(576);
  const [startDate, setStartDate] = React.useState<Date | null>(null);
  const [endDate, setEndDate] = React.useState<Date | null>(null);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: isMobile ? "wrap" : "nowrap",
          gap: 2,
        }}
      >
        <DatePicker
          label="Start Date"
          value={startDate}
          onChange={(date) => setStartDate(date)}
          slotProps={sharedSlotsProps}
        />
        <DatePicker
          label="End Date"
          value={endDate}
          onChange={(date) => setEndDate(date)}
          slotProps={sharedSlotsProps}
        />
      </Box>
    </LocalizationProvider>
  );
};

function FilterSearch({ isDarkMode }: IsDarkModeProp) {
  const [filterOpen, setFilterOpen] = useState(false);
  const toggleFilter = useCallback(() => {
    setFilterOpen((prev) => !prev);
  }, []);
  const styledComponentTheme = styledTheme();

  return (
    <>
      <FilterWrapper>
        <span onClick={toggleFilter} className="filtermenuCrlBtn">
          <SearchIcon
            src={isDarkMode ? filterWhite : filterDark}
            alt="filter icon"
          />
          Filter projects <button className="filterOpenerBtn">{filterOpen ? "\u2191" : "\u2193"}</button>
        </span>
      </FilterWrapper>

      {filterOpen && (
        <ModalBackground>
        <FilterContainer id="filterMenu">
          <div className="filterHeaderAndCloseBtn">
            <p className="filterHeader">Filter Projects</p>
            <button onClick={toggleFilter} className="closeBtn">
              {" "}
              &#10005;
            </button>
          </div>

          <CustomCheckBox />

          <div className="marginTopBottom filtermenuCrlBtn">
            <label htmlFor="filterOption" style={{ marginBottom: "5px" }}>
              Filter by type
            </label>
            <Select
              inputId="filterOption"
              // value={formData.service}
              // onChange={handleSelectChange}
              placeholder="Select project type"
              options={filterOptions}
              styles={getCustomStylesMultiSelect(styledComponentTheme, false, {
                control: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused
                    ? styledComponentTheme.searchInputBcgClrHver
                    : styledComponentTheme.searchInputBcg,
                  borderRadius: "25px",
                  borderWidth: "1px",
                  boxShadow: "none",
                  borderColor: state.isFocused
                    ? styledComponentTheme.text
                    : styledComponentTheme.searchInputBdrClr,
                  "&:hover": {
                    borderColor: styledComponentTheme.searchInputBdrClrHver,
                    backgroundColor: styledComponentTheme.searchInputBcgClrHver,
                  },
                }),
              })}
              isSearchable={false}
              isMulti
              menuPortalTarget={document.body}
              menuPosition="fixed"
              menuPlacement="auto" // Adjust dropdown placement dynamically
  
            />
          </div>

          <div className="marginTopBottom filtermenuCrlBtn">
            <p>Filter by date</p>
            <div>
              {" "}
              <FilterComponent />
            </div>
          </div>

          <div className="buttonAlignment">
            <Squarebtn
              width="170px"
              radius="18px"
              // onClick={openAddProject}
              $bacgrndColor={styledComponentTheme.text}
              $color={styledComponentTheme.circularIconTextBg}
              $hoverBackground={styledComponentTheme.circularIconTextBg}
              $hoverColor={styledComponentTheme.text}
            >
              Filter
            </Squarebtn>
          </div>
        </FilterContainer>
        </ModalBackground>
      )}
    </>
  );
}

export default FilterSearch;
